import { Box, Container } from "@mui/material";
import styles from "./AuthLayout.module.scss";

import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Logo from "../../assets/images/svgs/Bria-logo.svg";
import WhiteLogo from "../../assets/images/svgs/Bria-white-logo.svg";
import LoadingPlaceholder from "../../components/common/LoadingPlaceholder/LoadingPlaceholder.tsx";
import SelectOrganizationPopup from "../../components/common/SelectOrganizationPopup/SelectOrganizationPopup.tsx";
import RouterConstants from "../../constants/RouterConstants";
import { ThemeMode } from "../../constants/themes.ts";
import { useTheme } from "../../context/ThemeContext.tsx";
import { useAppStore } from "../../hooks/useStores.tsx";
import { PLUGIN_QUERY_PARAMS } from "../../pages/auth/store.tsx";
import { isPluginLogin, removeParamFromLocationUrl } from "../../utils/index.ts";
import { usePluginsUtils } from "../../utils/usePluginsUtils.tsx";
import { useTranslation } from "react-i18next";

interface LayoutProps {
	ignoreRedirect?: boolean;
}

const AuthLayout = ({ ignoreRedirect = false }: LayoutProps) => {
	const { authStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "selectOrganization" });
	const { verifyPluginAccess, handleSelectOrganization } = usePluginsUtils();
	const queryParams = new URLSearchParams(location.search);
	const continuURL = queryParams.get("continueUrl");
	const { mode } = useTheme();
	const logo = mode === ThemeMode.Dark ? WhiteLogo : Logo;

	useEffect(() => {
		if (isPluginLogin() && authStore.isLoggedIn && !authStore.isPluginLoginLoading) {
			authStore.isPluginAuth = true;
			handleSelectOrganization();
		}
	}, []);

	const onSelectOrganization = () => {
		authStore.handleShowSelectOrganizationPopup(false);
		authStore.handleChangePluginAuthId(queryParams.get("pluginAuthId") || undefined);
		const url = removeParamFromLocationUrl(PLUGIN_QUERY_PARAMS);
		window.history.replaceState({}, "", url.toString());
		verifyPluginAccess(authStore.selectedOrganization);
	};

	const getContent = () => {
		return (
			<Container component="main" maxWidth={false} className={clsx(styles.background, styles.container)}>
				<Box className={styles.box}>
					<img src={logo} className={styles.logo} />
				</Box>
				<Box className={styles.credentials_content}>
					<Outlet />
				</Box>
			</Container>
		);
	};
	return (
		<LoadingPlaceholder
			className={styles.loaderStyle}
			isLoading={authStore.isLoading || !authStore.isInitialized || authStore.isPluginLoginLoading}
		>
			{window.location.pathname === RouterConstants.PLUGIN_LOGIN.path &&
			authStore.isLoggedIn ? null : authStore.isLoggedIn && !ignoreRedirect && !authStore.isPluginAuth ? (
				<Navigate
					to={
						continuURL
							? continuURL
							: `${RouterConstants.CONSOLE.path}?${new URLSearchParams(location.search)}`
					}
				/>
			) : (
				getContent()
			)}
			<SelectOrganizationPopup
				open={authStore.showSelectOrganizationPopup}
				onClose={(_) => authStore.logout()}
				onSelect={authStore.handleSelectOrganization}
				onSubmit={onSelectOrganization}
				description={t("descriptionPluginAuth")}
				showLogo
			/>
		</LoadingPlaceholder>
	);
};

export default observer(AuthLayout);
